import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import utilCity from '@/libs/city.json';
var utilCityData = utilCity.map(function (v) {
  v.children.forEach(function (k) {
    return delete k.children;
  });
  return v;
});
export default {
  props: {
    collapseData: {
      type: Array,
      require: true,
      default: []
    }
  },
  data: function data() {
    return {
      activeNames: 0
    };
  },
  filters: {
    provincesName: function provincesName(e) {
      var str = [];
      e.forEach(function (v) {
        v.provinces.forEach(function (s) {
          var item = utilCityData.find(function (f) {
            return f.value == s.province;
          });
          str.push(item.label);

          if (s.cities && s.cities.length > 0 && !s.allCity) {
            s.cities.forEach(function (k) {
              return str.push(item.children.find(function (s) {
                return s.value == k;
              }).label);
            });
          }
        });
      });
      return str.join(',');
    }
  },
  methods: {
    itemClick: function itemClick(l, i) {
      this.activeNames = this.activeNames == i ? null : i;
      this.$emit('change', l);
    },
    isMoney: function isMoney(row) {
      return row.feeType == 1 ? '件(个)' : '重(kg)';
    },
    clickDel: function clickDel(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit('clickDel', data);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};